<template>
  <div class="py-m px-3 rounded-lg bg-beige leading-custom text-grey">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'BaseWarningBox',
};
</script>

<style lang="css" scoped>
.leading-custom {
  line-height: 22px;
}
</style>
